interface LogoProps {
  /** "light" for use on the dark green brand panel. */
  tone?: "dark" | "light";
}

export function Logo({ tone = "dark" }: LogoProps) {
  const light = tone === "light";

  return (
    <span className="inline-flex items-center gap-2.5">
      <span
        aria-hidden="true"
        className={`flex h-9 w-9 items-center justify-center rounded-[10px] font-display text-lg font-semibold ${
          light ? "bg-sun text-ink" : "bg-leaf-700 text-white"
        }`}
      >
        C
      </span>
      <span
        className={`font-display text-xl font-semibold tracking-tight ${light ? "text-white" : "text-ink"}`}
      >
        Cubby
      </span>
    </span>
  );
}
